<template>
	<div class="container-talktous">
		<div class="header-talktous">
			<i :style="{ color: parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)' }" @click="$router.push({ name: 'AccordionTabs' })" class="fas fa-times" />
		</div>
		<h3 :style="{ color: parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)' }">fale conosco</h3>
		<p class="sub-message">Escolha um canal para nos chamar</p>
		<div class="row-buttons" style="margin-top: 100px">
			<OutlineButton @click.native="salvarEtapa('email')" v-if="parceiroConfig.sessoes.omniChannel.campos.emailOmni != undefined" :text="'E-mail'" :icon="'fas fa-envelope-open-text fa-3x'" :color="'black'" :colorHover="'none'" :url="'mailto:' + parceiroConfig.sessoes.omniChannel.campos.emailOmni"></OutlineButton>
			<OutlineButton @click.native="salvarEtapa('instagram')" v-if="parceiroConfig.sessoes.omniChannel.campos.instagramOmni != undefined" :text="'Instagram'" :icon="'fab fa-instagram fa-3x'" :color="'purple'" :colorHover="'linear-gradient(45deg,#833ab4,#c13584,#e1306c,#fd1d1d, orange, yellow)'" :url="parceiroConfig.sessoes.omniChannel.campos.instagramOmni"></OutlineButton>
			<OutlineButton @click.native="salvarEtapa('linkedin')" v-if="parceiroConfig.sessoes.omniChannel.campos.linkedin != undefined" :text="'LinkedIn'" :icon="'fab fa-linkedin fa-3x'" :color="'#0a66c2'" :colorHover="'none'" :url="parceiroConfig.sessoes.omniChannel.campos.linkedin"></OutlineButton>
			<OutlineButton @click.native="salvarEtapa('messenger')" v-if="parceiroConfig.sessoes.omniChannel.campos.messenger != undefined" :text="'Messenger'" :icon="'fab fa-facebook-messenger fa-3x'" :color="'#2444d6'" :colorHover="'none'" :url="'http://m.me/' + parceiroConfig.sessoes.omniChannel.campos.messenger"></OutlineButton>
			<OutlineButton @click.native="salvarEtapa('telegram')" v-if="parceiroConfig.sessoes.omniChannel.campos.telegram != undefined" :text="'Telegram'" :icon="'fab fa-telegram fa-3x'" :color="'#0088cc'" :colorHover="'none'" :url="'https://t.me/' + parceiroConfig.sessoes.omniChannel.campos.telegram"></OutlineButton>
			<OutlineButton @click.native="salvarEtapa('skype')" v-if="parceiroConfig.sessoes.omniChannel.campos.usu_skype != undefined" :text="'Skype'" :icon="'fab fa-skype fa-3x'" :color="'#00aff0'" :colorHover="'none'" :url="'skype:' + parceiroConfig.sessoes.omniChannel.campos.usu_skype + '?chat'"></OutlineButton>
			<OutlineButton @click.native="salvarEtapa('whatsapp')" v-if="parceiroConfig.sessoes.omniChannel.campos.whatsappOmni != undefined" :text="'Whatsapp'" :icon="'fab fa-whatsapp fa-3x'" :color="'#4caf50'" :colorHover="'none'" :url="'https://wa.me/' + removeMaskCharacters(parceiroConfig.sessoes.omniChannel.campos.whatsappOmni)"></OutlineButton>
			<OutlineButton @click.native="salvarEtapa('meligue')" v-if="parceiroConfig.sessoes.omniChannel.campos.telefoneOmni != undefined" :text="'Me ligue'" :icon="'fas fa-phone fa-3x'" :color="'red'" :colorHover="'none'" :url="'callto:' + removeMaskCharacters(parceiroConfig.sessoes.omniChannel.campos.telefoneOmni)"></OutlineButton>
		</div>
	</div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import OutlineButton from "./components/OutlineButton";
import globalMethods from "@/mixins/globalMethods";
export default {
	name: "TalkToUs",
	mixins: [globalMethods],
	components: { OutlineButton },
	data() {
		return {};
	},
	mounted() {
		this.SET_LOADING(true);
		this.SET_LOADING_MESSAGE("Carregando meios de comunicação");
		window.fbq("trackCustom", "Fale Conosco");
		this.SET_LOADING_MESSAGE("");
		this.SET_LOADING(false);
	},
	computed: {
		...mapState({
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig,
			cpfCnpj: (state) => state.cpfCnpj
		})
	},
	methods: {
		...mapMutations(["SET_LOADING", "SET_LOADING_MESSAGE"]),
		...mapActions(["action_salvar_etapa"]),
		salvarEtapa(metodo) {
			this.action_salvar_etapa({
				cpfCnpj: this.cpfCnpj,
				esn_fk_ets_codigo: 15,
				emp_codigo: this.parceiroConfig.emp_codigo,
				motivo_agendamento: "Entrou em contato por " + metodo.toUpperCase()
			}).then((response) => {});
		}
	}
};
</script>

<style>
.container-talktous {
	padding: 50px;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #f3f5f9;
	flex: 1;
	box-sizing: border-box;
}

h3 {
	color: #031b4e;
	font-family: Montserrat-Bold;
	font-size: 28px;
	text-transform: uppercase;
}

.header-talktous {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	width: 100%;
	max-width: 750px;
	cursor: pointer;
}

.header-talktous i {
	font-size: 48px;
	color: #031b4e;
}

.sub-message {
	color: #5b6987;
	font-size: 14px;
	margin: 10px 0 10px 0;
}
</style>
